import { Runtime } from "@morphism/fp";
import React from "react";

import { Graph, gql } from "~/Graph";

export namespace Human {
  export type Name = {
    readonly name: {
      readonly first?: string;
      readonly last?: string;
      readonly display?: string;
    };
  };

  export function Name({ name: { first, last, display } }: Name): JSX.Element {
    return first && last ? (
      <>
        {first} {last}
      </>
    ) : first ? (
      <>{first}</>
    ) : last ? (
      <>{last}</>
    ) : display ? (
      <>{display}</>
    ) : (
      <>Name unknown</>
    );
  }

  export namespace Name {
    export type Fragment = Graph.Generated.NameFragment;
    export namespace Fragment {
      export const document = () => gql`
        fragment Name on Human__Name {
          first
          last
          display
        }
      `;

      export const decode = (original: Fragment): Name => ({
        name: {
          first: original.first ?? undefined,
          last: original.last ?? undefined,
          display: original.display ?? undefined,
        },
      });
    }

    export namespace Response {
      export const runtime = () =>
        Runtime.strict({
          first_name: Runtime.nullable(Runtime.string()),
          last_name: Runtime.nullable(Runtime.string()),
        });

      export const decode = (
        response: Runtime.ToType<typeof runtime>
      ): Name => ({
        name: {
          first: response.first_name ?? undefined,
          last: response.last_name ?? undefined,
        },
      });
    }
  }
}
